<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart-head flex-row flex-justify-start flex-align-start">累计故障数量</div>
    <div class="chart-contain flex-row flex-justify-center flex-align-start">
      <div id="errref" class="chart-area"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ErrChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    error: {
      type: Object,
      default: () => ({
        elect: [],
        water: [],
        flow: [],
        cold: []
      })
    }
  },
  data() {
    return {
      errorChart: null
    }
  },
  watch: {
    error: {
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.errorChart != null) {
      this.errorChart.dispose()
      this.errorChart = null
    }
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById('errref')
      if(!chartDom) {
        return
      }
      if (!this.errorChart) {
        this.errorChart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['电表', '水表', '空气流量计', '制冷机']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量 / 个',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '电表',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#97c4ff'
            },
            data: this.error.elect
          },
          {
            name: '水表',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#ff9f9f'
            },
            data: this.error.water
          },
          {
            name: '空气流量计',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#6aa4cf'
            },
            data: this.error.flow
          },
          {
            name: '制冷机',
            type: 'line',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            itemStyle: {
              color: '#f7cd85'
            },
            data: this.error.cold
          }
        ]
      }
      this.errorChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
.card-gap {
  margin-right: 1%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  margin-left: 20px;
  margin-top: 10px;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
